export const NAV_CATEGORIES = [
  { slug: "lucknow", name: "Lucknow", name_hi: "लखनऊ" },
  { slug: "uttar-pradesh", name: "Uttar Pradesh", name_hi: "उत्तर प्रदेश" },
  { slug: "crime", name: "Crime", name_hi: "क्राइम" },
  { slug: "politics", name: "Politics", name_hi: "राजनीति" },
  { slug: "national", name: "National", name_hi: "देश" },
  { slug: "international", name: "International", name_hi: "दुनिया" },
  { slug: "business", name: "Business", name_hi: "बिज़नेस" },
  { slug: "technology", name: "Technology", name_hi: "टेक" },
  { slug: "sports", name: "Sports", name_hi: "खेल" },
  { slug: "entertainment", name: "Entertainment", name_hi: "मनोरंजन" },
  { slug: "video", name: "Video", name_hi: "वीडियो" },
];

export const ALL_CATEGORIES = [
  ...NAV_CATEGORIES,
  { slug: "government", name: "Government", name_hi: "सरकार" },
  { slug: "education", name: "Education", name_hi: "शिक्षा" },
  { slug: "jobs", name: "Jobs", name_hi: "नौकरी" },
  { slug: "stock-market", name: "Stock Market", name_hi: "शेयर बाज़ार" },
  { slug: "viral", name: "Viral", name_hi: "वायरल" },
  { slug: "special-reports", name: "Special Reports", name_hi: "विशेष रिपोर्ट" },
  { slug: "investigation", name: "Investigation", name_hi: "पड़ताल" },
  { slug: "opinion", name: "Opinion", name_hi: "विचार" },
];

export const CAT_LABEL = ALL_CATEGORIES.reduce((a, c) => { a[c.slug] = c; return a; }, {});
